import { Box, Tabs } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

export const PDFDocumentWrapper = styled(Box, {
  base: {
    '& canvas': {
      width: '100% !important',
      height: 'auto !important',
    },
  },
});

export const TabPanel = styled(Tabs.Panel, {
  base: {
    overflow: 'scroll',
    maxHeight: { base: 'calc(100vh - 235px)', lg: '612px' },
  },
});
